import dateService from '../../../../services/date-service';

const getDefaultState = () => ({
  filter: {
    date: {
      arrivalFromDate: dateService.getIsoDateString(dateService.lastYear()),
      arrivalToDate: dateService.getIsoDateString(dateService.today()),
      paidDateFromDate: dateService.getIsoDateString(dateService.lastYear()),
      paidDateToDate: dateService.getIsoDateString(dateService.today()),
    },
    data: {
      loading: false,
      error: false,
      supplierSearch: undefined,
      selectedTableType: 1,
      selectedProductTypes: [],
      selectedBrands: [],
      selectedDomains: [],
      selectedSuppliers: [],
      productTypes: [],
      brands: [],
      domains: [],
      suppliers: [],
    },
    lastSearch: {
      performed: false,
      date: {},
      data: {},
    },
  },
  tableData: {
    rows: [],
    stays: [],
    loading: false,
    error: false,
    loaded: false,
  },
  download: {
    list: {
      loading: false,
      error: false,
    },
    specifications: {
      loading: false,
      error: false,
      name: undefined,
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/payments/supplierPayments/defaultState.js